import axios from 'axios'
const baseUrl = 'https://kaupunkisuunnistus-backend.vercel.app/api/login'
const setToken = newToken =>{
  const token = `bearer ${newToken}`
  return token
}
const login = async credentials => {
  const response = await axios.post(baseUrl, credentials)
  return response.data
}
const loginService = {login, setToken}
export default loginService